<template>
    <div v-if="requests" class="h-screen mt-5">
        <spinner></spinner>
    </div>
    <div v-else-if="region" class="medium-content">
        <div class="text-center text-yanone">
            <div class="d-flex mb">
                <router-link
                    :to="{ name: 'home' }"
                    class="flex-child-fixed text-primary text-uppercase"
                >
                    <span>
                        <i class="icon-cr icon-chevron-left" />
                        Ver mapa
                    </span>
                </router-link>
                <div class="ml-auto flex-child-fixed text-uppercase">
                    <a
                        :href="shareFacebookUrl"
                        onclick="openSharePopup(shareFacebookUrl)"
                        target="popup"
                        title="Compartilhe no Facebook"
                    >
                        <span>
                            <i class="icon-cr icon-facebook text-primary" />
                        </span>
                    </a>
                    <a
                        :href="shareTwitterUrl"
                        onclick="openSharePopup(shareTwitterUrl)"
                        target="popup"
                        title="Compartilhe no Twittter"
                    >
                        <span>
                            <i class="icon-cr icon-twitter text-primary" />
                        </span>
                    </a>
                </div>
            </div>
            <div class="bg-default-1 aspect aspect-xs-21-9 rounded mb hidden-xs-up">
                <img
                    :data-src="`${
                        $scope.CDN_IMAGES
                    }/images/site/2020/brasilidade/mobile_${region.name.toLowerCase()}.jpg`"
                    class="lazy lazy-fade"
                />
            </div>
            <div class="bg-default-1 aspect aspect-xs-125-34 rounded mb hidden-xs-down">
                <img
                    :data-src="`${
                        $scope.CDN_IMAGES
                    }/images/site/2020/brasilidade/desktop_${region.name.toLowerCase()}.jpg?w=800`"
                    class="lazy lazy-fade"
                />
            </div>
            <div class="d-flex flex-justify-center text-info text-uppercase">
                <router-link
                    :class="{
                        'text-primary': $route.name !== `${regionName}-home`,
                        'text-bold': $route.name === `${regionName}-home`,
                    }"
                    :to="{ name: `${regionName}-home` }"
                    class="flex-item-grow"
                >
                    Início
                </router-link>
                <router-link
                    v-if="region.products.data.length"
                    :class="{
                        'text-primary': $route.name !== `${regionName}-products`,
                        'text-bold': $route.name === `${regionName}-products`,
                    }"
                    :to="{ name: `${regionName}-products` }"
                    class="flex-item-grow"
                >
                    Produtos
                </router-link>
                <router-link
                    v-if="region.partners.data.length"
                    :class="{
                        'text-primary': $route.name !== `${regionName}-collections`,
                        'text-bold': $route.name === `${regionName}-collections`,
                    }"
                    :to="{ name: `${regionName}-collections` }"
                    class="flex-item-grow"
                >
                    Coleções
                </router-link>
                <router-link
                    v-if="podcasts.length"
                    :class="{
                        'text-primary': $route.name !== `${regionName}-podcasts`,
                        'text-bold': $route.name === `${regionName}-podcasts`,
                    }"
                    :to="{ name: `${regionName}-podcasts` }"
                    class="flex-item-grow"
                >
                    Podcasts
                </router-link>
                <router-link
                    v-if="posts.length"
                    :class="{
                        'text-primary': $route.name !== `${regionName}-blog`,
                        'text-bold': $route.name === `${regionName}-blog`,
                    }"
                    :to="{ name: `${regionName}-blog` }"
                    class="flex-item-grow"
                >
                    Blog
                </router-link>
            </div>
        </div>

        <hr />

        <router-view :region="region" />
    </div>
</template>

<script>
    import Spinner from '../../../../../submodules/src/components/feedback/spinner/Spinner.vue';
    import { countryRegionService } from '../../../common/service/resource';
    import ProductGroup from '../product/ProductGroup';
    import ProductGroupList from '../product/ProductGroupList';
    import CountryRegionPodcast from './CountryRegionPodcast';
    import CountryRegionBlogPost from './CountryRegionBlogPost';

    export default {
        name: 'CountryRegion',

        components: {
            CountryRegionBlogPost,
            CountryRegionPodcast,
            ProductGroupList,
            ProductGroup,
            Spinner,
        },

        props: {
            regionName: String,
        },

        data() {
            return {
                requests: 0,
                region: null,
            };
        },

        watch: {
            regionName: {
                immediate: true,
                handler() {
                    this.fetchRegion();
                },
            },
        },

        computed: {
            posts() {
                return this.region.resources.data.filter(
                    (r) => r.url.indexOf('https://blog') === 0
                );
            },

            podcasts() {
                return this.region.resources.data.filter(
                    (r) => r.url.indexOf('https://open.spotify') === 0
                );
            },

            shareFacebookUrl() {
                return `https://www.facebook.com/dialog/share?app_id=416962708352552&display=popup&href=${
                    this.$scope.URL
                }${this.$route.path.substr(1)}`;
            },

            shareTwitterUrl() {
                return `https://twitter.com/intent/tweet?text=Veja o conteúdo da Chico Rei para a região ${
                    this.region.name
                }&url=${this.$scope.URL}${this.$route.path.substr(1)}&via=chicorei`;
            },
        },

        methods: {
            fetchRegion() {
                this.requests++;
                countryRegionService
                    .query({
                        name: this.regionName,
                        include: ['products', 'partners', 'resources'],
                    })
                    .then((response) => (this.region = response.data.data[0]))
                    .catch(() => {})
                    .then(() => this.requests--);
                // todo catch
            },

            openSharePopup(url) {
                window.open(url, 'popup', 'width=600,height=600');
                return false;
            },
        },
    };
</script>
